import { Switch } from "antd";
import { formatUTCTime } from "../../../global/utils/unixToLocalTime";

export const DeviceOrderItemChildColumns = [
  {
    title: "License Item",
    dataIndex: "LicenseItem",
    key: "LicenseItem",
    width: 150,
  },
  {
    title: "Old License",
    dataIndex: "OldCode",
    key: "OldCode",
    width: 150,
  },
  {
    title: "New License",
    dataIndex: "NewCode",
    key: "NewCode",
    width: 150,
  },
  {
    title: "Free",
    dataIndex: "Free",
    key: "Free",
    width: 80,
    render: (value) =>
      value === 1 || value === "Yes" || value === true
        ? "Yes"
        : value === 0 || value === "No" || value === false
          ? "No"
          : (value ?? ""),
  },
  {
    title: "",
    dataIndex: "",
    key: "",
    width: 1,
  },
];

export const DeviceOrderItemColumns = ({
  onRenewalToggle,
  editableRenewal = false,
} = {}) => {
  return [
    {
      title: "Order Time",
      dataIndex: "OrderTime",
      key: "OrderTime",
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Order Type",
      dataIndex: "OrderType",
      key: "OrderType",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "License Item",
      dataIndex: "LicenseItem",
      key: "LicenseItem",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "License Code",
      dataIndex: "LicenseCode",
      key: "LicenseCode",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Term",
      dataIndex: "Term",
      key: "Term",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Start Time",
      dataIndex: "StartTime",
      key: "StartTime",
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Renewal",
      dataIndex: "Renewal",
      key: "Renewal",
      render: (value, record) =>
        editableRenewal ? (
          <Switch
            size="small"
            checked={Number(value) === 1}
            onChange={(checked) => onRenewalToggle?.(record, checked)}
          />
        ) : (
          <div>{Number(value) === 1 ? "Yes" : "No"}</div>
        ),
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
    },
  ];
};
